import React, { useEffect, useRef, useState } from "react";
import { renderError } from "../../../helpers/errors";
import { createFilterQueryString } from "../../../helpers/helpers";
import { createOptions } from "../../../helpers/selects";
import api from "../../../services/api";
import InputSelect from "../../InputSelect";

const SEARCH_DEBOUNCE_MS = 300;
const MAX_RESULTS_PER_PAGE = 50;

// Select (com busca no servidor) de marcas. Suporta seleção única ou múltipla.
export const SelectBrand = ({ label, selectedBrand, setSelectedBrand, isMulti, changeBrands, minSearch }) => {
    minSearch = minSearch ?? 1;

    const [brands, setBrands] = useState([]);
    const [search, setSearch] = useState('');
    const [noOptionsText, setNoOptionsText] = useState('');
    const debounceRef = useRef(null);

    useEffect(() => {
        if (debounceRef.current) clearTimeout(debounceRef.current);

        if (search.length < minSearch) {
            const diff = minSearch - search.length;
            setNoOptionsText(`Digite mais ${diff} ${diff === 1 ? 'caracter' : 'caracteres'}`);
            handleSetBrands([], true);
            if (window.brandRequestController) window.brandRequestController.abort();
            return;
        }

        debounceRef.current = setTimeout(() => searchBrands(), SEARCH_DEBOUNCE_MS);
        return () => {
            if (debounceRef.current) clearTimeout(debounceRef.current);
        };
    }, [search]);

    useEffect(() => {
        checkIfNeedToGet();
    }, [selectedBrand]);

    useEffect(() => {
        if (changeBrands) changeBrands(brands);
    }, [brands]);

    const checkIfNeedToGet = () => {
        const brandIds = isMulti ? (selectedBrand ?? []) : [selectedBrand];
        const arrayFilters = [];

        brandIds.map(brandId => {
            if (brandId === null || brandId === undefined) return;
            if (!brands.some(brand => brand.id === brandId)) {
                arrayFilters.push([`[id][equal]=${brandId}`]);
            }
        });

        if (arrayFilters.length > 0) {
            getBrands(arrayFilters);
        } else {
            setSearch('');
        }
    };

    const searchBrands = () => {
        getBrands([[`[name][contain]=${search}`]]);
    };

    const getBrands = arrayFilters => {
        const stringFilters = createFilterQueryString(arrayFilters);

        if (window.brandRequestController) window.brandRequestController.abort();
        window.brandRequestController = new AbortController();

        handleSetBrands([], true);
        setNoOptionsText('Carregando...');

        api.get(`/brand?${stringFilters}per_page=${MAX_RESULTS_PER_PAGE}`, {
            signal: window.brandRequestController.signal
        }).then(res => {
            const raw = res.data?.resources?.data ?? res.data?.resources ?? [];
            handleSetBrands(Array.isArray(raw) ? raw : []);
        }).catch(error => {
            if (error.name !== 'CanceledError' && error.code !== 'ERR_CANCELED') {
                setNoOptionsText('Erro ao carregar. Tente novamente.');
                if (error.code !== undefined) renderError(error);
            }
        });
    };

    const handleSetBrands = (resources, fromClear = false) => {
        const currentSelected = getSelectedBrands();
        const toBrands = resources.filter(resource => !currentSelected.some(current => current.id === resource.id));

        setBrands([...currentSelected, ...toBrands]);
        if (!fromClear) {
            setNoOptionsText(toBrands.length === 0 ? 'Nenhum resultado encontrado' : '');
        }
    };

    const getSelectedBrands = () => {
        return brands.filter(brand => {
            if (isMulti) return (selectedBrand ?? []).includes(brand.id);
            return selectedBrand === brand.id;
        });
    };

    return (
        <InputSelect
            noOptionsText={noOptionsText}
            label={label ?? 'Marca'}
            options={createOptions(brands, 'name', 'id')}
            value={selectedBrand}
            change={setSelectedBrand}
            isMulti={isMulti === true}
            setSearch={value => setSearch(value)}
        />
    );
};

export default SelectBrand;
